(() => {
  const theme = window.theme;
  if (!theme || typeof theme.preloadProductModal !== 'function') return;

  const nativePreload = theme.preloadProductModal;
  const pending = new Map();
  const replaying = new WeakSet();
  const ready = holder => Boolean(holder && holder.querySelector('.product-section'));

  function waitForProduct(holder) {
    return new Promise((resolve, reject) => {
      if (!holder) { reject(new Error('Quick view holder missing')); return; }
      if (ready(holder)) { resolve(); return; }
      let timer;
      const observer = new MutationObserver(() => {
        if (!ready(holder)) return;
        observer.disconnect();
        clearTimeout(timer);
        resolve();
      });
      observer.observe(holder, {childList: true, subtree: true});
      timer = setTimeout(() => {
        observer.disconnect();
        reject(new Error('Quick view load timed out'));
      }, 8000);
    });
  }

  theme.preloadProductModal = function(handle, productId, button) {
    const key = String(productId);
    const holder = document.getElementById('QuickShopHolder-' + handle);
    if (ready(holder)) return Promise.resolve();
    if (pending.has(key)) return pending.get(key);
    const promise = waitForProduct(holder);
    pending.set(key, promise);
    promise.then(() => pending.delete(key), () => pending.delete(key));
    nativePreload.call(this, handle, productId, button);
    return promise;
  };

  document.addEventListener('click', event => {
    const button = event.target.closest('.quick-product__btn');
    if (!button || replaying.has(button)) return;
    const card = button.closest('.grid-product');
    if (!card || !card.dataset.productHandle || !card.dataset.productId) return;
    const handle = card.dataset.productHandle;
    const holder = document.getElementById('QuickShopHolder-' + handle);
    if (ready(holder)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const clearBusy = () => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    };

    theme.preloadProductModal(handle, card.dataset.productId, button).then(() => {
      clearBusy();
      if (!button.isConnected) return;
      replaying.add(button);
      button.click();
      replaying.delete(button);
    }).catch(() => {
      clearBusy();
      if (!button.isConnected) return;
      const prefix = (theme.routes.home || '/').replace(/\/$/, '');
      window.location.assign(prefix + '/products/' + encodeURIComponent(handle));
    });
  }, true);
})();
